import { ContactDealerFormDetailsProps } from '../../../types';
import styles from '../../../Product.module.scss';
import cx from 'classnames';

export const ContactDealerFormDetails = ({
  formLinkLabel,
  formHeading,
  textClassName,
  contactUsURL
}: ContactDealerFormDetailsProps) => {
  const contactUsLink = (
    <a className="text-lowercase" href={contactUsURL}>
      {formLinkLabel}
    </a>
  );
  const replaceContactUsLink = (msg: string) => {
    const split = msg?.split('{0}');
    return (
      <>
        <span className={cx(textClassName, styles['product-text'])}>
          {split[0]}
        </span>
        {contactUsLink}
        <span className={cx(textClassName, styles['product-text'])}>
          {split[1]}
        </span>
      </>
    );
  };

  return <p className={textClassName}>{replaceContactUsLink(formHeading)}</p>;
};
